var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
var File = function File(props) {
  return React.createElement(
    Icon,
    _extends({ viewBox: '0 0 13 15' }, props),
    React.createElement(
      'g',
      null,
      React.createElement('path', { d: 'M11 14H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5v4.5a.5.5 0 0 0 .5.5H12v7a1 1 0 0 1-1 1zM8 1.996L11.008 5H8V1.996zM13 5L8 0H2a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h9a2 2 0 0 0 2-2V5z',
        fill: 'currentColor', fillRule: 'evenodd' })
    )
  );
};
/*eslint-enable */

export default File;
//# sourceMappingURL=File.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/Icons/dist/components/File.js